/* Observe existing providers only; never load a second tracker or send commerce. */
(function (window, document) {
  'use strict';
  if (window.hbAnalyticsProviders || !window.hbAnalyticsIdentity) return;
  var identity = window.hbAnalyticsIdentity, state = null, listeners = [];
  var generation = 0, timer, attempts = 0, clarityQueued = false, googleQueued = false, identified = false;
  function current(g) {
    var live = identity.getSnapshot();
    return g === generation && state && live && live.visitor_id === state.visitor_id && live.consent_epoch === state.consent_epoch;
  }
  function snapshot() { return current(generation) ? Object.assign({}, state) : null; }
  function notify() { listeners.slice().forEach(function (cb) { try { cb(snapshot()); } catch (_) {} }); }
  function cookieClient() {
    try {
      var values = document.cookie.split(';').map(function (part) { return part.trim(); })
        .filter(function (part) { return part.indexOf('_ga=') === 0; })
        .map(function (part) { return part.slice(4); });
      if (!values.length || values.some(function (v) { return v !== values[0]; })) return null;
      var match = /^GA\d+\.\d+\.(\d+\.\d+)$/.exec(values[0]);
      return match ? match[1] : null;
    } catch (_) { return null; }
  }
  function consent() {
    if (typeof window.clarity !== 'function') return;
    var c = window.hbConsentMode && window.hbConsentMode.lastGoogleState || {};
    if (c.wait_for_update != null && !snapshot()) return;
    try { window.clarity('consentv2', {
      analytics_Storage: c.analytics_storage === 'granted' ? 'granted' : 'denied',
      ad_Storage: c.ad_storage === 'granted' ? 'granted' : 'denied'
    }); } catch (_) {}
  }
  function discover(g) {
    if (!current(g)) return;
    attempts += 1;
    if (state.ga_id_source !== 'gtag') {
      var id = cookieClient();
      if (id && id !== state.ga_client_id) { state.ga_client_id = id; state.ga_id_source = 'ga_cookie'; notify(); }
    }
    if (!googleQueued && typeof window.gtag === 'function') {
      googleQueued = true;
      ['client_id', 'session_id'].forEach(function (field) {
        try { window.gtag('get', 'G-3KBBV847BB', field, function (value) {
          if (!current(g)) return;
          var v = String(value);
          if (!(field === 'client_id' ? /^\d+\.\d+$/ : /^\d+$/).test(v)) return;
          state['ga_' + field] = v;
          if (field === 'client_id') state.ga_id_source = 'gtag';
          notify();
        }); } catch (_) {}
      });
    }
    if (!clarityQueued && typeof window.clarity === 'function') {
      clarityQueued = true; consent();
      try { window.clarity('metadata', function () {
        if (!current(g) || identified) return;
        identified = true;
        try { window.clarity('identify', state.visitor_id); } catch (_) {}
      }, true); } catch (_) {}
    }
    // Give app pixels time to initialize without indefinite retries.
    if (attempts < 20 && (!clarityQueued || !state.ga_client_id)) {
      timer = window.setTimeout(function () { discover(g); }, 500);
    }
  }
  window.hbAnalyticsProviders = {
    getSnapshot: snapshot,
    subscribe: function (cb) {
      if (typeof cb !== 'function') return function () {};
      listeners.push(cb); try { cb(snapshot()); } catch (_) {}
      return function () { listeners = listeners.filter(function (fn) { return fn !== cb; }); };
    }
  };
  identity.subscribe(function (value) {
    generation += 1; window.clearTimeout(timer); attempts = 0; clarityQueued = false; googleQueued = false; identified = false;
    state = value ? {schema: 1, visitor_id: value.visitor_id, consent_epoch: value.consent_epoch} : null;
    consent(); notify(); if (state) discover(generation);
  });
  if (window.hbConsentMode) window.hbConsentMode.addListener(consent);
})(window, document);
